import React, { Fragment } from 'react';
import './estilosComponente.css';

const ListaCarrera =()=>{

    const[index,setIndex]=React.useState(0);

    const handleClick =(event)=>{
        event.preventDefault();
        setIndex(index + 1);
    };

    const handleClickBack =(event)=>{
        event.preventDefault();
        setIndex(0);
    };

    const listCarrera = [
        "Bachelor's Degree in Business Management",
        'Front End Development Libraries Certification',
        'Javascript Algorithms and Data Structures Certification',
        'Responsive Web Design Certification',
        'Learning programming in Python Certification',
        'Purchase and Supply Chain Certification',
        'Master Mathematics Certification'
    ];

    const listEstablecimiento = [
        'Rafael Landívar University',
        'freeCodeCamp',
        'freeCodeCamp',
        'freeCodeCamp',
        'Udemy',
        'Florida International University',
        'CONAMAT'
    ];

    return(
        <Fragment>
            <div id="contenedor-lista">
                <div id="icono-lista">
                    {
                        listEstablecimiento[index] === 'Rafael Landívar University' || listEstablecimiento[index] === 'Florida International University'
                        ? <i className="fas fa-graduation-cap"></i>
                        : listEstablecimiento[index] === 'freeCodeCamp'
                        ? <i className="fab fa-free-code-camp"></i>
                        : listEstablecimiento[index] === 'Udemy'
                        ? <i className="fas fa-code-branch"></i>
                        : index > 6
                        ? <i className="fas fa-bookmark"></i>
                        : <i className="fas fa-infinity"></i>
                    }
                </div>
                <h1 id="carrera">
                    {   index > 6
                        ? 'True life consists in living for others'
                        : listCarrera[index]
                    }
                </h1>
                <h2 id="establecimiento">
                    {
                        index > 6
                        ? 'Bruce Lee'
                        : listEstablecimiento[index]
                    }
                </h2>
                <button onClick={handleClick} id=
                {
                    index <= 6
                    ? 'boton-lista'
                    : 'invisible'
                }
                >Next</button>
                <button onClick={handleClickBack} id=
                {
                    index > 6
                    ? 'boton-lista'
                    : 'invisible'
                }
                >Back</button>
            </div>
        </Fragment>
    );
};

export default ListaCarrera;